import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function DeleteNotification({
  open,
  setOpen,
  selectedData,
  handleDeleteNotification,
  data,
  isLoading,
}) {
  const notificationTitles =
    selectedData?.length > 0
      ? selectedData.map((item) => item.title).join(", ")
      : data?.title;

  const handleDelete = () => {
    if (selectedData?.length > 0) {
      const ids = selectedData?.map((item) => item.id);
      handleDeleteNotification(ids);
    } else {
      handleDeleteNotification([data.id]);
    }
  };

  return (
    <ModalComp
      title="Delete Notification"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setOpen(false)}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={isLoading}
          handleSecondaryBtn={handleDelete}
          secondaryBtnvariant="danger"
          secondaryBtnText="Delete"
        />
      }
      open={open}
      setOpen={setOpen}
    >
      {selectedData?.length > 1
        ? "Are you sure you want to delete the selected notifications"
        : `Are you sure you want to delete the notification titled '${notificationTitles}'`}
    </ModalComp>
  );
}

export default DeleteNotification;
